import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOPatientFarmacologicRecord extends BOGeneralValues{
    id:number;
    tempId?:string;
    patientId:number;
    code:string;
    name:string;
    enabled:boolean;
}
